var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E5E7",
    d: "M9 0a2.257 2.257 0 0 0-2.25 2.25v31.5A2.257 2.257 0 0 0 9 36h22.5a2.257 2.257 0 0 0 2.25-2.25V9l-9-9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M27 9h6.75l-9-9v6.75A2.257 2.257 0 0 0 27 9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M33.75 15.75 27 9h6.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F15642",
    d: "M29.25 29.25c0 .619-.506 1.125-1.125 1.125H3.375A1.13 1.13 0 0 1 2.25 29.25V18c0-.619.506-1.125 1.125-1.125h24.75c.619 0 1.125.506 1.125 1.125z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.154 21.315c0-.297.234-.62.61-.62h2.079c1.17 0 2.223.782 2.223 2.283 0 1.422-1.053 2.214-2.223 2.214H8.34v1.188c0 .396-.252.62-.576.62a.606.606 0 0 1-.611-.62zm1.187.512v2.241h1.502c.603 0 1.08-.532 1.08-1.09 0-.629-.477-1.15-1.08-1.15zM13.827 27c-.297 0-.62-.162-.62-.557v-5.11c0-.322.323-.558.62-.558h2.06c4.11 0 4.02 6.225.081 6.225zm.567-5.127v4.03h1.493c2.429 0 2.537-4.03 0-4.03zM21.366 21.946v1.43h2.294c.324 0 .648.323.648.637 0 .297-.324.54-.648.54h-2.294v1.89c0 .314-.224.556-.539.556-.396 0-.638-.242-.638-.557v-5.11c0-.323.243-.558.638-.558h3.158c.396 0 .63.235.63.558a.62.62 0 0 1-.63.612h-2.619z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M28.125 30.375H6.75V31.5h21.375c.619 0 1.125-.506 1.125-1.125V29.25c0 .619-.506 1.125-1.125 1.125"
  })));
};
export default SvgPdf;